






























import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import TooltipHeading from '../../misc/TooltipHeading.vue'
import TooltipMeta from '../TopInfo/TooltipMeta.vue'

@Component({
    components: {
        TooltipHeading,
        TooltipMeta,
    },
})
export default class NetworkActivity extends Vue {
    @Prop() aggregates!: any
    @Prop() scope!: string

    get prefix() {
        return `1-${this.scope}`
    }
}
